//This file is automatically rebuilt by the Cesium build process.
export default "const float czm_epsilon4 = 0.0001;\n\
";
